import { Button, Markdown, PageFooter } from "@quark/design";
import CoachPage from "../coach-page";
import { useEffect, useState } from "react";
import styles from "./index.module.scss";

export interface ChallengeProps {
  step: number;
  data: Record<string, any>;
  onPrev?: () => void;
  onNext?: () => void;
}

const Challenge = ({ data, step, onPrev, onNext }: ChallengeProps) => {
  const [submitted, setSubmitted] = useState(false);
  const [showCoachPage, setShowCoachPage] = useState(false);
  useEffect(() => {
    if (data.user_data) {
      setSubmitted(true);
    }
  }, []);

  const handleOpenCoachPage = () => {
    setShowCoachPage(true);
  };
  const handleSubmit = () => {
    setSubmitted(true);
  };

  const renderPrev = () => {
    if (step > 1) {
      return (
        <Button variant="outlined" onClick={onPrev}>
          返回
        </Button>
      );
    }
    return <div />;
  };

  const renderNext = () => {
    if (submitted) {
      return (
        <div className={styles.next}>
          <Button variant="outlined" onClick={handleOpenCoachPage}>
            重新挑战
          </Button>
          <Button variant="filled" onClick={onNext}>
            继续
          </Button>
        </div>
      );
    }
    return (
      <div>
        <Button variant="filled" onClick={handleOpenCoachPage}>
          去挑战
        </Button>
      </div>
    );
  };
  return (
    <>
      <div className="container">
        <h2>{data.title}</h2>
      </div>
      <div className="container">
        <Markdown children={data?.problem_statement_md} />
      </div>
      {!showCoachPage && (
        <PageFooter>
          {renderPrev()}
          {renderNext()}
        </PageFooter>
      )}
      <CoachPage
        challengeId={data.challenge_id}
        visible={showCoachPage}
        onClose={() => setShowCoachPage(false)}
        onSubmitReturn={handleSubmit}
      />
    </>
  );
};

export default Challenge;
